import { createElementBlock as i, createCommentVNode as c, openBlock as r, normalizeClass as n, createElementVNode as d, createVNode as l, Fragment as m, renderList as a } from "vue";
import { themeProp as g } from "../../composables/useTheme.js";
import h from "../../molecules/intro-text/intro-text.vue.js";
import _ from "./components/metric-card/metric-card.vue.js";
/* empty css                           */
import u from "../../_virtual/_plugin-vue_export-helper.js";
const f = {
  key: 0,
  class: "ds-container ds-margin-bottom-48"
}, p = { class: "ds-grid" }, y = { class: "ds-grid__col ds-grid__col--12 ds-lg-grid__col--8" }, v = { class: "ds-container" }, x = { class: "ds-grid ds-highlight-box-metrics__grid ds-flex-direction-row" }, k = /* @__PURE__ */ Object.assign({
  name: "DsHighlightBoxMetrics"
}, {
  __name: "highlight-box-metrics",
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (e) => e.every((t) => ["metric", "description"].every((o) => o in t))
    },
    ...g,
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    link: {
      type: Object,
      default: null,
      validator: (e) => ["title", "url", "openInNewWindow", "nuxt"].every((t) => t in e)
    }
  },
  setup(e) {
    return (t, o) => e.items && e.items.length ? (r(), i("section", {
      key: 0,
      class: n([`ds-highlight-box-metrics--${t.theme}`, "ds-highlight-box-metrics ds-padding-y-24 ds-md-padding-y-48"])
    }, [
      e.title ? (r(), i("div", f, [
        d("div", p, [
          d("div", y, [
            l(h, {
              title: e.title,
              text: e.text,
              link: e.link,
              theme: t.theme
            }, null, 8, ["title", "text", "link", "theme"])
          ])
        ])
      ])) : c("", !0),
      d("div", v, [
        d("div", x, [
          (r(!0), i(m, null, a(e.items, (s) => (r(), i("div", {
            key: `item-${s.metric}`,
            class: "ds-grid__col ds-grid__col--12 ds-md-grid__col--6 ds-lg-grid__col--3",
            "data-j-card-container": ""
          }, [
            l(_, {
              metric: s.metric,
              description: s.description,
              theme: t.theme
            }, null, 8, ["metric", "description", "theme"])
          ]))), 128))
        ])
      ])
    ], 2)) : c("", !0);
  }
}), M = /* @__PURE__ */ u(k, [["__scopeId", "data-v-498897b6"]]);
export {
  M as default
};
